import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateItemUnitEntity } from '../../domain/entities/CreateUpdateItemUnitEntity'

export class CreateUpdateItemUnitModel extends CreateUpdateItemUnitEntity {
  translations = []
  constructor(dataDto: CreateUpdateItemUnitEntity) {
    super()
    mapEntityProperties<CreateUpdateItemUnitModel>(this, dataDto)
  }
}
